import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import UserModule from "@/store/modules/UserModule";
import DiscountsModule from "@/store/modules/DiscountsModule";
import InvoiceModule from "@/store/modules/InvoiceModule";
import LogsModule from "@/store/modules/LogModule";
import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import ServicesModule from "@/store/modules/ServicesModule";
import SettingsModule from "@/store/modules/SettingsModule";
import YoutubeChannelModule from "@/store/modules/YoutubeChannelModule";
import YoutubeInvoicesModule from "@/store/modules/YoutubeInvoicesModule";
import TicketModule from "@/store/modules/TicketModule";
import KeywordPlannerModule from "@/store/modules/KeywordPlannerModule";
import AccountsNumberModule from "@/store/modules/AccountsNumberModule";
import AccountTransactionsModule from "@/store/modules/AccountTransactionsModule";
import CounterpartyTransactionModule from "@/store/modules/CounterpartyTransactionModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    ConfigModule,
    ThemeModeModule,
    UserModule,
    DiscountsModule,
    InvoiceModule,
    ServicesModule,
    SettingsModule,
    LogsModule,
    YoutubeChannelModule,
    YoutubeInvoicesModule,
    TicketModule,
    KeywordPlannerModule,
    AccountsNumberModule,
    AccountTransactionsModule,
    CounterpartyTransactionModule,
  },
});

export default store;
